import { CANDY_APPLE, MARIGOLD, MARIGOLD_LIGHT, OLAF, EERIE } from 'HubStyleTokens/colors';
import UIIconCircle from 'UIComponents/icon/UIIconCircle';
import { SLAStatus } from 'find-and-filter-data/view-members-schema/public';
import { jsx as _jsx } from "react/jsx-runtime";
const SLA_BADGE_ICON_SIZE = 12;
const SLA_BADGE_ICON_PADDING_EM = 0.3;
const getColorMap = (status, isHelpDesk) => {
  switch (status) {
    case SLAStatus.IN_SLA:
      return {
        borderStyle: isHelpDesk ? 'solid' : 'unset',
        borderWidth: isHelpDesk ? 1 : 0,
        backgroundColor: isHelpDesk ? OLAF : '',
        color: EERIE
      };
    case SLAStatus.SLA_WARNING:
      return {
        color: MARIGOLD,
        backgroundColor: MARIGOLD_LIGHT
      };
    case SLAStatus.BREACHED:
      return {
        backgroundColor: CANDY_APPLE,
        color: OLAF,
        borderColor: CANDY_APPLE
      };
    case SLAStatus.RESOLVED_IN_SLA:
    case SLAStatus.RESOLVED_OUTSIDE_SLA:
      return {
        color: '',
        backgroundColor: ''
      };
    default:
      return {};
  }
};
const PreviewCardSLAIcon = ({
  status = SLAStatus.IN_SLA,
  size = SLA_BADGE_ICON_SIZE,
  padding = SLA_BADGE_ICON_PADDING_EM,
  className,
  isHelpDesk
}) => {
  if (!status) return null;
  const {
    color,
    backgroundColor,
    borderColor,
    borderWidth,
    borderStyle
  } = getColorMap(status, isHelpDesk);
  return /*#__PURE__*/_jsx(UIIconCircle, {
    className: className,
    "data-test-id": "sla-icon",
    name: "time",
    color: color,
    backgroundColor: backgroundColor,
    size: size,
    padding: padding,
    borderColor: borderColor,
    borderWidth: borderWidth,
    borderStyle: borderStyle,
    innerStyles: {
      paddingTop: '1px'
    }
  });
};
PreviewCardSLAIcon.displayName = 'PreviewCardSLAIcon';
export default PreviewCardSLAIcon;